import Cleave from 'cleave.js'

export default {
  methods: {
    inputPriceFormat(id, numeralDecimalScale = 2, valueChangedCallback = () => {}) {
      this.$nextTick(() => {
        const delimiter = this.settings.thousand_separator
        // eslint-disable-next-line
        new Cleave(id, {
          numeral: true,
          numeralDecimalMark: this.settings.decimal_separator,
          delimiter: delimiter === 'space' ? ' ' : delimiter,
          numeralDecimalScale,
          onValueChanged: valueChangedCallback
        })
      })
    }
  }
}
